import { render } from "./ModalDefault.vue?vue&type=template&id=71451b3a&ts=true"
import script from "./ModalDefault.vue?vue&type=script&lang=ts"
export * from "./ModalDefault.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__